// src/NotificationsPanel.js

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from './firebase';
import { doc, updateDoc } from 'firebase/firestore';
import moment from 'moment';
import './NotificationsPanel.css'; // Creeremo subito questo file

const NotificationsPanel = ({ notifications, onClose }) => {
    const navigate = useNavigate();

    // Quando il pannello si apre, segna tutte le notifiche visibili come lette
    useEffect(() => {
        const unreadNotifications = notifications.filter(n => !n.isRead);
        
        const markAsRead = async () => {
            for (const notification of unreadNotifications) {
                const notifRef = doc(db, 'notifications', notification.id);
                await updateDoc(notifRef, { isRead: true });
            }
        };

        if (unreadNotifications.length > 0) {
            markAsRead();
        }
    }, [notifications]);

    const handleNotificationClick = (notification) => {
        onClose(); // Chiude il pannello
        navigate(notification.link); // Porta l'utente alla pagina specificata
    };

    return (
        <div className="notifications-panel">
            <div className="notifications-header">
                <h3>Notifiche</h3>
            </div>
            <div className="notifications-list">
                {notifications.length > 0 ? (
                    notifications.map(n => (
                        <div
                            key={n.id}
                            className={`notification-item ${!n.isRead ? 'unread' : ''}`}
                            onClick={() => handleNotificationClick(n)}
                        >
                            <p><strong>{n.senderName}</strong> {n.message}</p>
                            <span className="timestamp">{moment(n.timestamp?.toDate()).fromNow()}</span>
                        </div>
                    ))
                ) : (
                    <p className="no-notifications">Nessuna notifica</p>
                )}
            </div>
        </div>
    );
};

export default NotificationsPanel;